import { useEffect } from 'react';
import useSelection from 'hooks/useSelection';

/**
 * Hook to automatically select client if there's only one available
 * This ensures client context is initialized across the application
 * Uses the centralized client loading from SelectionContext
 */
const useClientAutoSelector = () => {
  const { selectedClient, clientOptions, isLoadingClients } = useSelection();

  useEffect(() => {
    // Only auto-select if no client is currently selected, 
    // clients are loaded, and there's exactly one client
    if (!selectedClient && !isLoadingClients && clientOptions.length === 1) {
      console.log('Client auto-selection handled by SelectionContext');
    }
  }, [selectedClient, clientOptions, isLoadingClients]);

  return { selectedClient, clientOptions, isLoadingClients };
};

export default useClientAutoSelector;
